export interface Volume {
  title: string;
  border: string;
  items: string[];
  result?: string;
}

export interface Bonus {
  number: string;
  title: string;
  value: string;
  details: string[];
  result?: string;
}

export const volumes: Volume[] = [
  {
    title: 'Volumen 1 — Mapa de la Historia Médica™',
    border: 'border-blue-400/30',
    items: [
      'Convertís 10 años de papeles en UNA CARPETA que el neurólogo comprende en 2 minutos',
      'Creás una línea de tiempo que muestra qué funcionó y qué no',
      'Preparás un resumen de UNA PÁGINA para médico nuevo'
    ],
    result: 'Nunca más “no tengo ese estudio”'
  },
  {
    title: 'Volumen 2 — Registro Inteligente de Crisis™',
    border: 'border-green-400/30',
    items: [
      'Aprendés QUÉ OBSERVAR para que el médico tenga DATOS',
      'Documentás cada crisis en 2 minutos mientras lo recordás claro',
      'El neurólogo VE PATRONES que vos no veías sola'
    ],
    result: 'Cada crisis genera información para cambiar el tratamiento'
  },
  {
    title: 'Volumen 3 — Preguntas Que Importan™',
    border: 'border-amber-400/30',
    items: [
      'Escribís las 5 preguntas MÁS IMPORTANTES ANTES de la consulta',
      'Las ordenás por importancia',
      'Salís CON LAS RESPUESTAS ANOTADAS, no con dudas'
    ],
    result: 'Entendés el plan de tratamiento sin esperar semanas'
  },
  {
    title: 'Volumen 4 — La Consulta en Orden™',
    border: 'border-yellow-400/30',
    items: [
      'Plan de 7 días: QUÉ HACER cada día',
      'Checklist final de 3 minutos antes de entrar',
      'Frases listas para el consultorio'
    ],
    result: 'Bajás el estrés porque SABÉS que estás lista'
  }
];

export const includedExtras = [
  'Plan de 7 días listo para arrancar hoy',
  'Plantillas imprimibles para la carpeta',
  'Guía de registro de observaciones',
  'Checklist para el día de la consulta'
];

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Kit Consulta Lista en 24 Horas™',
    value: '$12.000',
    details: [
      'Los 7 documentos que el neurólogo SIEMPRE pregunta',
      'Guía para preparar la carpeta sin estrés',
      'Checklist de 3 minutos antes de entrar'
    ]
  },
  {
    number: '02',
    title: 'Guion de Consulta Clara™',
    value: '$10.000',
    details: [
      'Las 8 frases EXACTAS para explicar sin nerviosismo',
      'Cómo preguntar sin miedo a molestar'
    ],
    result: 'Salís habiendo comunicado TODO lo que importa'
  },
  {
    number: '03',
    title: 'Resumen Médico Express de 1 Página™',
    value: '$11.000',
    details: [
      'La plantilla EXACTA donde cabe toda la historia clínica en UNA PÁGINA',
      'El neurólogo entiende en MENOS DE UN MINUTO',
      'Listo para cualquier consulta'
    ]
  },
  {
    number: '04',
    title: 'Semáforo de Dudas y Prioridades™',
    value: '$9.000',
    details: [
      'Matriz: ROJO (urgentes), AMARILLO (importantes), VERDE (espera)',
      'Priorizás en 5 minutos',
      'Nunca más salís sin preguntar lo principal'
    ]
  },
  {
    number: '05',
    title: 'Carpeta Digital Neurológica Ordenada™',
    value: '$10.000',
    details: [
      'Encontrás cualquier archivo en 3 segundos',
      'Escaneás estudios en minutos',
      'Toda la historia clínica en tu teléfono',
      'Compartís con el médico por WhatsApp'
    ]
  }
];
